import { useState } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import SmsSignup from "@/pages/home/components/SmsSignup";
import InventorySection from "@/pages/home/components/InventorySection";
import AboutSection from "@/pages/home/components/AboutSection";
import ReviewsCarousel from "@/pages/home/components/ReviewsCarousel";
import LocationSection from "@/pages/home/components/LocationSection";
import TextUsButton from "@/components/feature/TextUsButton";
import { useInventory } from "@/hooks/useInventory";

export default function HomePage() {
  const [activeRValue, setActiveRValue] = useState<string | null>(null);
  const inventory = useInventory();

  const handleRValueClick = (rValue: string) => {
    setActiveRValue(rValue);
    const el = document.getElementById("inventory");
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Navbar />
      <main className="flex-1">
        <SmsSignup
          onRValueClick={handleRValueClick}
          activeRValue={activeRValue}
          inStockRValues={inventory.inStockRValues}
          inventoryLoading={inventory.loading}
        />
        <InventorySection
          activeRValue={activeRValue}
          onClearFilter={() => setActiveRValue(null)}
          inventory={inventory}
        />
        <ReviewsCarousel />
        <LocationSection />
        <AboutSection />
      </main>
      <Footer />
      <TextUsButton />
    </div>
  );
}
